import React, { Component } from 'react';

import axios from "../../../../utils/config-axios";
import {buildLogMessage} from "../../../../utils/error-helper";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import Carousel from 'react-bootstrap/Carousel';

import classes from './TestimonialCarousel.module.scss';
import TestimonialCarouselItem from "./TestimonialCarouselItem";


/**
 * CHECKED-2021
 */
class TestimonialCarousel extends Component {


    state = {
        testimonialArray:[]
    };


    componentDidMount(){
        this.getTestimonials();
    }


    getTestimonials = (searchTxt, categoryArray) => {


        axios({
            url: '/api/public/testimonials/get-all',
            method: 'GET'
        }).then(result => {

            // console.log("testimonialArray", result);

            this.setState({
                testimonialArray:result.data.testimonialArray
            })

        }).catch(error => {
            //
            // Silently fail.
            //
            console.log("Failed to get testimonials.", buildLogMessage(error) );
        });
    };


    buildTestimonals = () => {

        if( !this.state.testimonialArray )
        {
            return null;
        }

        return this.state.testimonialArray.map(testimonial => {
            return (
            <Carousel.Item key={"ts-"+testimonial.id} className={""} interval={10000}>
                <TestimonialCarouselItem testimonial={testimonial}/>
            </Carousel.Item>
            );
        })
    };


    render() {

        const testimonials = this.buildTestimonals();

        if(!testimonials || testimonials.length===0){
            return null;
        }

        return (
            <div className={"light-gray-bg pb-4 " + classes.TestimonialCarousel + " " +(this.props.className?this.props.className:"")}>
                <Container>
                    <Row className={"mt-4"}>
                        <h2 className={"mt-4 mb-4"}>What People Are Saying</h2>
                    </Row>
                    <Row className={"mb-4 "}>
                        <Carousel fade controls={false} className={"testimonial-carousel"}>
                            {testimonials}
                        </Carousel>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default TestimonialCarousel;
